import { render, staticRenderFns } from "./Telefono.vue?vue&type=template&id=9567a722&scoped=true&"
import script from "./Telefono.vue?vue&type=script&lang=js&"
export * from "./Telefono.vue?vue&type=script&lang=js&"
import style0 from "./Telefono.vue?vue&type=style&index=0&id=9567a722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9567a722",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VIcon,VTextField,VTooltip})
